// @core/api/endpoints/product/list_product_reviews.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductReviewsResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List product reviews
 * Returns approved reviews for a product. Supports sorting by rating and date.
 * @public This endpoint does not require authentication
 */
export async function ListProductReviews(
  product_id: string,
  params?: PaginatedRequest & {
    sort_by?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListProductReviewsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/reviews`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductReviewsResponse>(requestPath, { ...requestOptions, params });
}
